import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Courtesy landing page. The magic link email points directly to the server
 * endpoint /api/auth/magic-link/verify which sets the session cookie and
 * redirects to /dashboard. If anything links to /verify directly, we just
 * bounce them to /dashboard (which will redirect to /login if needed).
 */
export default function VerifyPage({ onAuth }: { onAuth: () => Promise<void> }) {
  const navigate = useNavigate();
  const ranRef = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;
    void (async () => {
      try {
        await onAuth();
        navigate('/dashboard', { replace: true });
      } catch {
        setError(true);
      }
    })();
  }, [navigate, onAuth]);

  return (
    <div className="mx-auto max-w-md py-16 text-center">
      {!error ? (
        <p className="text-muted">One moment…</p>
      ) : (
        <>
          <p className="text-text">That link is invalid or expired.</p>
          <p className="mt-2 text-sm text-muted">
            Head back to the <a href="/login" className="text-amber hover:underline">sign in page</a> and request a new one.
          </p>
        </>
      )}
    </div>
  );
}
